import React, { PureComponent, Fragment } from 'react'
import { connect } from 'react-redux'

import FlowManager from 'components/FlowManager'
import OnboardingBotFlowRoutes from './routes'
import { BOT_STEP_COUNT, STEP_COUNT_TOTAL } from '../constants'

import { getCustomerSegment } from 'modules/billing/selectors'

const STEP_TOTAL = STEP_COUNT_TOTAL - BOT_STEP_COUNT

const mapStateToProps = (state) => {
  return {
    segment: getCustomerSegment(state)
  }
}

class OnboardingBotFlow extends PureComponent {
  render() {
    const { match, history, segment } = this.props

    return (
      <Fragment>
        <FlowManager steps={OnboardingBotFlowRoutes} stepTotal={STEP_TOTAL} stepOffset={STEP_TOTAL} baseUrl={match.url} history={history} segment={segment} name='Playbook Onboarding'/>
      </Fragment>
    )
  }
}

export default connect(mapStateToProps, null)(OnboardingBotFlow)



// WEBPACK FOOTER //
// ./src/flows/OnboardingFlow/OnboardingBotFlow/index.js